import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';

import {
  clearResults,
  fetchBarberCustomerResults,
  fetchShopCustomerResults,
} from '../../main/search/actions';
import { getSearchResults } from '../../main/search/selectors';

const withFetchCustomerResults = compose(
  connect(
    state => ({
      shop: state.auth.shop,
      barberUser: state.auth.barberUser,
      results: getSearchResults(state),
    }),
    {
      fetchShopCustomerResults,
      fetchBarberCustomerResults,
      clearResults,
    },
  ),
  withHandlers({
    fetchCustomerResults: props => (searchText) => {
      if (props.barberUser) {
        return props.fetchBarberCustomerResults(searchText);
      }

      return props.fetchShopCustomerResults(searchText);
    },
  })
);

export default withFetchCustomerResults;
